"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondaryH6 = exports.SecondaryH5 = exports.SecondaryH4 = exports.SecondaryH3 = exports.SecondaryH2 = exports.SecondaryH1 = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../Constant");

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  && {\n    font-family: ", ";\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  && {\n    font-family: ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  && {\n    font-family: ", ";\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  && {\n    font-family: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  && {\n    font-family: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  && {\n    font-family: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SecondaryH1 = _styledComponents.default.h1(_templateObject(), _Constant.Font.SECONDARY_HEADER_FONT);

exports.SecondaryH1 = SecondaryH1;

var SecondaryH2 = _styledComponents.default.h2(_templateObject2(), _Constant.Font.SECONDARY_HEADER_FONT);

exports.SecondaryH2 = SecondaryH2;

var SecondaryH3 = _styledComponents.default.h3(_templateObject3(), _Constant.Font.SECONDARY_HEADER_FONT);

exports.SecondaryH3 = SecondaryH3;

var SecondaryH4 = _styledComponents.default.h4(_templateObject4(), _Constant.Font.SECONDARY_HEADER_FONT);

exports.SecondaryH4 = SecondaryH4;

var SecondaryH5 = _styledComponents.default.h5(_templateObject5(), _Constant.Font.SECONDARY_HEADER_FONT);

exports.SecondaryH5 = SecondaryH5;

var SecondaryH6 = _styledComponents.default.h6(_templateObject6(), _Constant.Font.SECONDARY_HEADER_FONT);

exports.SecondaryH6 = SecondaryH6;
SecondaryH1.displayName = 'SecondaryH1';
SecondaryH2.displayName = 'SecondaryH2';
SecondaryH3.displayName = 'SecondaryH3';
SecondaryH4.displayName = 'SecondaryH4';
SecondaryH5.displayName = 'SecondaryH5';
SecondaryH6.displayName = 'SecondaryH6';